export const randomId = () =>
  Math.random()
    .toString(36)
    .substring(2, 6 + 2);
